<div *ngIf="wrapped && !group" class="form-group" [ngClass]="wrappedClass">
  <label for="{{name}}">{{label || (name | stringSpacer)}}</label>
  <input #input type="text" id="{{name}}" [attr.disabled]="disabled ? 'disabled' : null" name="{{name}}" [ngClass]="class" autocomplete="{{autoComplete}}" maxlength="{{maxlength}}"
    placeholder="{{placeholder}}" [(ngModel)]="model" (ngModelChange)="modelChanged($event)" (focus)="focused($event)" (blur)="lostFocus($event)" />
</div>

<input #input *ngIf=" !wrapped && !group" type="text" id="{{name}}" [attr.disabled]="disabled ? 'disabled' : null" name="{{name}}" [ngClass]="class" autocomplete="{{autoComplete}}"
  maxlength="{{maxlength}}" placeholder="{{placeholder}}" [(ngModel)]="model" (ngModelChange)="modelChanged($event)" (focus)="focused($event)"
  (blur)="lostFocus($event)" />

<div *ngIf="wrapped && group" class="form-group" [ngClass]="wrappedClass">
  <label for="{{name}}">{{label || (name | stringSpacer)}}</label>
  <div class="input-group">
    <input #input type="text" id="{{name}}" [attr.disabled]="disabled ? 'disabled' : null" name="{{name}}" [ngClass]="class" autocomplete="{{autoComplete}}" maxlength="{{maxlength}}"
      placeholder="{{placeholder}}" [(ngModel)]="model" (ngModelChange)="modelChanged($event)" (focus)="focused($event)" (blur)="lostFocus($event)" />
    <span *ngIf="!disabled" class="input-group-append">
      <span (click)="groupButtonClicked()" [attr.disabled]="groupButtonDisabled ? 'disabled' : null" class="btn btn-sm" [ngClass]="groupButtonClass"><i class="fa fa-{{groupButtonIcon}}"></i> {{groupButtonText}}</span>
    </span>
    <ng-content class="input-group-append"></ng-content>
  </div>
</div>

<div *ngIf="!wrapped && group" class="input-group">
  <input #input type="text" id="{{name}}" [attr.disabled]="disabled ? 'disabled' : null" name="{{name}}" [ngClass]="class" autocomplete="{{autoComplete}}" maxlength="{{maxlength}}"
    placeholder="{{placeholder}}" [(ngModel)]="model" (ngModelChange)="modelChanged($event)" (focus)="focused($event)" (blur)="lostFocus($event)" />
  <span *ngIf="!disabled" class="input-group-append">
    <span (click)="groupButtonClicked()" [attr.disabled]="groupButtonDisabled ? 'disabled' : null" class="btn btn-sm" [ngClass]="groupButtonClass"><i class="fa fa-{{groupButtonIcon}}"></i> {{groupButtonText}}</span>
  </span>
  <ng-content class="input-group-append"></ng-content>
</div>
